import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from '../index'

interface ThemeState {
  darkMode: boolean
}

const initialState: ThemeState = {
  darkMode: localStorage.getItem('darkMode') === 'true' || false,
}

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    // toggleDarkMode(state) {
    //   state.darkMode = !state.darkMode
    //   localStorage.setItem('darkMode', state.darkMode.toString())
    // },
    setDarkMode(state, action: PayloadAction<boolean>) {
      state.darkMode = action.payload
      localStorage.setItem('darkMode', state.darkMode.toString())
    },
  },
})

export const {setDarkMode} = themeSlice.actions

export const selectDarkMode = (state: RootState) => state.theme.darkMode

export default themeSlice.reducer
